<template>
	<v-list-item style="border: 1px solid #e0e0e0; border-radius: 5px">
		<v-list-item-icon class="mr-3">
			<v-icon>person</v-icon>
		</v-list-item-icon>
		<v-list-item-content>
			<v-list-item-title>
				<strong>{{patient.name}}</strong>
			</v-list-item-title>
		</v-list-item-content>
		<v-list-item-action>
			<v-row no-gutters>
				<v-tooltip top>
					<template v-slot:activator="{ on }">
						<v-btn icon @click="$emit('restore',patient)" v-on="on">
							<v-icon color="primary">mdi-backup-restore</v-icon>
						</v-btn>
					</template>
					<span v-translate>Restore</span>
				</v-tooltip>
				<v-tooltip top>
					<template v-slot:activator="{ on }">
						<v-btn icon @click="showDeletePatient = true" v-on="on">
							<v-icon color="primary">delete</v-icon>
							<DeleteConfirmationDialog
								v-model="showDeletePatient"
								item="user"
								@delete="$emit('delete',patient); showDeletePatient=false"
							/>
						</v-btn>
					</template>
					<span v-translate>Delete</span>
				</v-tooltip>
			</v-row>
		</v-list-item-action>
	</v-list-item>
</template>

<script>
import DeleteConfirmationDialog from "@/components/DeleteConfirmationDialog.vue";

export default {
	name: "PatientItem",
	props: ["patient"],
	components: {
		DeleteConfirmationDialog
	},
	data: () => ({
		showDeletePatient: false
	})
};
</script>